import SeoLoader from "@/components/SeoLoader/SeoLoader";

function SeoLoaderModule() {
  return (<SeoLoader />);
}
    
export default SeoLoaderModule;
